module.exports = __webpack_public_path__ + "img/bg-hero-home.bd526aa.jpg";